import type { LucideIcon } from 'lucide-react';

interface AccordionItemDesktopProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

const AccordionItemDesktop = ({
  icon: Icon,
  title,
  description,
}: AccordionItemDesktopProps) => {
  return (
    <div className="flex w-full gap-3.5">
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#C8B49615]">
        <Icon className="h-[18px] w-[18px] text-accent-primary" />
      </div>
      <div className="flex flex-1 flex-col gap-1">
        <span className="font-body text-sm font-semibold text-foreground-primary">
          {title}
        </span>
        <p className="font-body text-[13px] leading-[1.4] text-foreground-secondary">
          {description}
        </p>
      </div>
    </div>
  );
};

export default AccordionItemDesktop;
